import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=4bf7f41d"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=4bf7f41d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports